import {
  Box,
  Button,
  Card,
  CardContent,
  CardMedia,
  Typography,
} from "@mui/material";
import QuickReferencesStyle from "../QuickReferencesStyle";
import { FC } from "react";
import { CMSContentStyles } from "./CMSContentStyles";

interface IContentCard {
  id: string;
  imageUrl: string;
  Heading: string;
  handleReadMore: (id: string) => void;
}
const ContentCard: FC<IContentCard> = ({
  id,
  imageUrl,
  Heading,
  handleReadMore,
}) => {
  return (
    <Card 
      id={`cmscontent_card-${id}`}
      data-test-id={`test-cmscontent_card-${id}`}
      aria-label="Quick Reference Card"
      key={id} 
      sx={CMSContentStyles?.CMSContentCard}
    >
      <CardMedia
        id={`cmscontent_card-image-${id}`}
        data-test-id={`test-cmscontent_card-image-${id}`}
        aria-label={`Image for ${Heading}`}
        component="img"
        src={imageUrl}
        alt={Heading || ""}
        sx={{ height: "180px" }}
      />
      <CardContent 
        id={`cmscontent_card-content-${id}`}
        data-test-id={`test-cmscontent_card-content-${id}`}
        aria-label="Quick Reference Content"
        sx={CMSContentStyles?.CMSContentCardContent}
      >
        <Typography 
          id={`cmscontent_card-heading-${id}`}
          data-test-id={`test-cmscontent_card-heading-${id}`}
          aria-label="Quick Reference Heading"
          sx={CMSContentStyles?.CMSContentHeading}
        >
          {Heading}
        </Typography>
        <Button
          id={`cmscontent_read-more-button-${id}`}
          data-test-id={`test-cmscontent_read-more-button-${id}`}
          aria-label={`Read More about ${Heading}`}
          variant="outlined"
          sx={QuickReferencesStyle.readMoreBtn}
          onClick={() => handleReadMore(id)}
        >
          Read More
        </Button>
      </CardContent>
    </Card>
  );
};

export default ContentCard;
